import axios from "src/utils/axios";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  isLoading: false,
  error: false,
  distributors: [],
  distributor: null,
};

const slice = createSlice({
  name: "distributors",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getDistributorsSuccess(state, action) {
      state.isLoading = false;
      state.distributors = action.payload;
    },
    getDistributorSuccess(state, action) {
      state.isLoading = false;
      state.distributor = state.distributors.find(
        (u) => u.id == action.payload
      );
    },
    addDistributorSuccess(state, action) {
      state.isLoading = false;
      state.distributors = [...state.distributors, action.payload];
    },
    updateDistributorSuccess(state, action) {
      const distributor = action.payload;

      state.isLoading = false;

      state.distributors = state.distributors.map((d) => {
        if (d.id === distributor.id)
          return {
            ...d,
            ...distributor,
          };

        return d;
      });
    },
    deleteDistributorSuccess(state, action) {
      state.isLoading = false;
      state.distributors = state.distributors.map((d) => {
        if (d.id === action.payload) {
          return {
            ...d,
            isActive: false,
          };
        }

        return d;
      });
    },
    activateDistributorSuccess(state, action) {
      state.isLoading = false;
      state.distributors = state.distributors.map((d) => {
        if (d.id === action.payload) {
          return {
            ...d,
            isActive: true,
          };
        }

        return d;
      });
    },

    cleanDistributor(state) {
      state.isLoading = false;
      state.distributor = null;
    },
  },
});

export default slice.reducer;

export const {
  startLoading,
  hasError,
  getDistributorsSuccess,
  getDistributorSuccess,
  addDistributorSuccess,
  updateDistributorSuccess,
  deleteDistributorSuccess,
  activateDistributorSuccess,
  cleanDistributor,
} = slice.actions;

export function getDistributors() {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const response = await axios.get("distributor/read");
      const data = response.data;

      dispatch(getDistributorsSuccess(data));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

// -------------------------------------------------------

export function addDistributor(distributor) {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const response = await axios.post("distributor/create", distributor);
      const data = response.data;

      dispatch(addDistributorSuccess(data));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

// -------------------------------------------------------

export function updateDistributor(distributor) {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      const response = await axios.put(`distributor/update`, distributor);
      const data = response.data;

      dispatch(updateDistributorSuccess(data));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

// -------------------------------------------------------

export function deleteDistributor(id) {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      await axios.delete(`distributor/delete/${id}`);
      dispatch(deleteDistributorSuccess(id));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

// -------------------------------------------------------

export function activateDistributor(id) {
  return async (dispatch) => {
    dispatch(startLoading());

    try {
      await axios.put(`distributor/activate/${id}`);
      dispatch(activateDistributorSuccess(id));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}
